var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ConvoModal from "./ConvoModal";
import { useTranslation } from "react-i18next";
var ActionErrorModal = function (_a) {
    var errorText = _a.errorText, isOpened = _a.isOpened, onClose = _a.onClose, _b = _a.error, error = _b === void 0 ? {} : _b;
    var t = useTranslation(["chat"]).t;
    return (_jsx(ConvoModal, { title: t(errorText.title), isModalOpen: isOpened, handleClose: onClose, modalBody: _jsx("div", __assign({ className: "modal-body" }, { children: t(errorText.description) })), modalFooter: _jsx(_Fragment, { children: _jsx("button", __assign({ type: "button", className: "btn btn-secondary compact modal-cancel-button me-1", onClick: onClose }, { children: t("Cancel") })) }) }));
};
export default ActionErrorModal;
